module.exports = __webpack_public_path__ + "static/img/home-swiper-2.d1c8b7a6.png";